import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery, baseQueryWithAuthHandling } from "../utils/utils";
import { API_METHODS } from "./constants";
import { OPENWEATHER_ENDPOINTS } from "./endpoints";
import { handleAuthErrorCode } from "./errorCodes";
import { WeatherHistoryResponse } from "../types/Weather";

export const WeatherApis = createApi({
  reducerPath: "weatherAPI",
  baseQuery: (args, api, extraOptions) =>
    baseQueryWithAuthHandling(appBaseQuery.noAuth, args, api, extraOptions),
  endpoints: (builder) => ({
    // weather forecast
    weather: builder.query<any, { lat: number; lon: number; units: string }>({
      query: ({ lat, lon, units }) => {
        return {
          url: OPENWEATHER_ENDPOINTS.WEATHER_FORECAST(lat, lon, units),
          method: API_METHODS.GET,
        };
      },
      transformErrorResponse(baseQueryReturnValue) {
        handleAuthErrorCode(baseQueryReturnValue);
        return baseQueryReturnValue;
      },
      transformResponse: (response) => {
        return response;
      },
    }),

    // startDateTime/endDateTime must be formatted via utils/weatherHistory.ts formatHodDateTime
    weatherHistory: builder.query<
      WeatherHistoryResponse,
      { lat: number; lon: number; startDateTime: string; endDateTime: string; units: string }
    >({
      query: ({ lat, lon, startDateTime, endDateTime, units }) => {
        return {
          url: OPENWEATHER_ENDPOINTS.WEATHER_HISTORY(lat, lon, startDateTime, endDateTime, units),
          method: API_METHODS.GET,
        };
      },
      transformErrorResponse(baseQueryReturnValue) {
        handleAuthErrorCode(baseQueryReturnValue);
        return baseQueryReturnValue;
      },
      transformResponse: (response: WeatherHistoryResponse) => {
        return response;
      },
    }),
  }),
});

export const { useWeatherQuery, useWeatherHistoryQuery } = WeatherApis;
